// Plain objects instead of new Lead()/Group()/User() to avoid circular imports
// at module-load time. The actions (setContextLead, etc.) replace them with
// real entity instances at runtime.
export default {
    divisionId: null,
    group: {},
    groupId: null,
    leadId: null,
    lead: {},
    teamId: null,
    user: {},
    userId: null,

    // Context Lead
    currentMergeAction: '',
    mergeManualCheckDuplicate: false,
    communicatingLeads: [],
    hideSensitiveInfoMode: false,
    phoneIsEnabled: false,
    emailIsEnabled: false,
    smsIsEnabled: false,
};
